import { render, staticRenderFns } from "./JournalProductInTransitView.vue?vue&type=template&id=2e50ed27"
import script from "./JournalProductInTransitView.vue?vue&type=script&lang=js"
export * from "./JournalProductInTransitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports